// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fromTop {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes toTop {
  from {
    transform: translateY(0%);
  }
  to {
    transform: translateY(-100%);
  }
}
.notification-wrapper {
  display: block;
}

.notification-message {
  display: flex;
  flex-direction: row;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 9999;
  border: 0;
  font-weight: 300;
  min-height: 70px;
  border-radius: 0;
  animation: fromTop 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53) forwards;
  color: #fff;
}

.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;
  background: rgba(236, 236, 236, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 993px) {
  .notification-message,
  .global-loading {
    left: 70px;
    right: 0;
  }
}
.sidebar-enable .notification-message,
.sidebar-enable .global-loading {
  left: 70px;
}

.notification-message--hide {
  animation: toTop 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53) forwards;
}

.notification-message__header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  z-index: 1;
  line-height: 1;
}
.notification-message__header a {
  color: #fff;
  cursor: pointer;
  text-decoration: underline;
}

.notification-message__action {
  padding: 4px 12px;
  border-radius: 3px;
  margin-left: 4px;
  cursor: pointer;
}
.notification-message__action:hover {
  text-decoration: none;
}

.notification-message__link {
  color: #fff;
  cursor: pointer;
  text-decoration: underline;
}

.notification-message__icon {
  margin-right: 12px;
}

.notification-message--default {
  color: #fff;
}

.notification-message--success {
  background-color: #0e8a09;
}

.notification-message--warning {
  color: #333;
  background-color: #efbb12;
}

.notification-message--error {
  background-color: #d73737;
}

.notification-message--info {
  background-color: #0070f0;
}

.notification-message__close {
  position: absolute;
  text-decoration: none;
  text-shadow: none;
  opacity: 1;
  display: inline-block;
  border-left: 1px solid #fff;
  line-height: 45px;
  height: 100%;
  top: 0px;
  right: 0px;
  padding: 12px 16px;
  width: 90px;
  cursor: pointer;
}

div#notification-message p {
  margin: 0;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Notification/styles/Message.scss"],"names":[],"mappings":"AAAA;EACE;IACE,4BAAA;EACF;EACA;IACE,wBAAA;EACF;AACF;AAEA;EACE;IACE,yBAAA;EAAF;EAEA;IACE,4BAAA;EAAF;AACF;AAGA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EAEA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uEAAA;EACA,WAAA;AAFF;;AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAGA;EACE;;IAEE,UAAA;IACA,QAAA;EAAF;AACF;AAGE;;EAEE,UAAA;AADJ;;AAIA;EACE,qEAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;AADF;AAEE;EACE,WAAA;EACA,eAAA;EACA,0BAAA;AAAJ;;AAIA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AADF;AAGE;EACE,qBAAA;AADJ;;AAKA;EACE,WAAA;EACA,eAAA;EACA,0BAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,WAAA;EACA,yBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAIA;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;EACA,qBAAA;EACA,2BAAA;EACA,iBAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;AADF","sourcesContent":["@keyframes fromTop {\n  from {\n    transform: translateY(-100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes toTop {\n  from {\n    transform: translateY(0%);\n  }\n  to {\n    transform: translateY(-100%);\n  }\n}\n\n.notification-wrapper {\n  display: block;\n}\n\n.notification-message {\n  display: flex;\n  flex-direction: row;\n  text-align: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  // To keep this notification above header component\n  z-index: 9999;\n  border: 0;\n  font-weight: 300;\n  min-height: 70px;\n  border-radius: 0;\n  animation: fromTop 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53) forwards;\n  color: #fff;\n}\n.global-loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1002;\n  background: rgba(236, 236, 236, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media screen and (max-width: 993px) {\n  .notification-message,\n  .global-loading {\n    left: 70px;\n    right: 0;\n  }\n}\n.sidebar-enable {\n  .notification-message,\n  .global-loading {\n    left: 70px;\n  }\n}\n.notification-message--hide {\n  animation: toTop 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53) forwards;\n}\n\n.notification-message__header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  z-index: 1;\n  line-height: 1;\n  a {\n    color: #fff;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n.notification-message__action {\n  padding: 4px 12px;\n  border-radius: 3px;\n  margin-left: 4px;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n.notification-message__link {\n  color: #fff;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.notification-message__icon {\n  margin-right: 12px;\n}\n\n.notification-message--default {\n  color: #fff;\n}\n\n.notification-message--success {\n  background-color: #0e8a09;\n}\n\n.notification-message--warning {\n  color: #333;\n  background-color: #efbb12;\n}\n\n.notification-message--error {\n  background-color: #d73737;\n}\n\n.notification-message--info {\n  background-color: #0070f0;\n}\n.notification-message__close {\n  position: absolute;\n  text-decoration: none;\n  text-shadow: none;\n  opacity: 1;\n  display: inline-block;\n  border-left: 1px solid #fff;\n  line-height: 45px;\n  height: 100%;\n  top: 0px;\n  right: 0px;\n  padding: 12px 16px;\n  width: 90px;\n  cursor: pointer;\n}\n\ndiv#notification-message p {\n  margin: 0;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
